import { HostProps } from '@/utils/commonFunc';
import { useState } from 'react';
import { useLocalStorage } from './storage/useLocalStorage';

const useChatRoomDisplay = () => {
    const [isChatPanelEnabled, setIsChatPanelEnabled] = useLocalStorage(
        'chat_room',
        true
    ); //setting
    const [showOtherPlayerGift, setShowOtherPlayerGift] = useLocalStorage(
        'other_player_gift',
        true
    ); //setting
    const [loginReady, setLoginReady] = useState<boolean>(false);
    const [joinRoom, setJoinRoom] = useState<HostProps>();
    return {
        isChatPanelEnabled,
        setIsChatPanelEnabled,
        showOtherPlayerGift,
        setShowOtherPlayerGift,
        loginReady,
        setLoginReady,
        joinRoom,
        setJoinRoom,
    };
};

export default useChatRoomDisplay;
export type useChatRoomDisplayState = ReturnType<typeof useChatRoomDisplay>;
